import React from 'react';
import styled from 'styled-components';

// Create a Wrapper component that'll render a <section> tag with some styles
const StyledParagraphText = styled.div`
  display: flex;
  font-weight: ${props => props.bold ? '600' : '500'};
  font-size: 1rem;
  text-align: left;
  max-width: 800px;
  
  ${props => props.style }
`;

const ParagraphText = (props) => (<StyledParagraphText style={props.style} bold={props.bold} className={props.className}>{props.children || ''}</StyledParagraphText>);

export default ParagraphText;


// WEBPACK FOOTER //
// ./src/Components/ParagraphText.js